import { useEffect } from 'react';

const getLinks = (selector: string): HTMLCollectionOf<HTMLAnchorElement> | [] =>
  document.querySelector(selector)?.getElementsByTagName('a') || [];

interface Props {
  onLinkClick: (event: MouseEvent) => void;
}

export const useHeaderFooterLinkEventListener = ({ onLinkClick }: Props) => {
  useEffect(() => {
    const headerLinks = getLinks('header[role="banner"]') as any;
    const footerLinks = getLinks('footer') as any;

    const links = [...headerLinks, ...footerLinks];

    if (links.length > 0) {
      setTimeout(() => {
        for (const item of links) {
          item.addEventListener('click', onLinkClick, true);
        }
      }, 0);

      return () => {
        for (const item of links) {
          item.removeEventListener('click', onLinkClick);
        }
      };
    }
  }, [onLinkClick]);
};
